import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';
import { autosaveInfoColor } from 'styles/Colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: fit-content;
  height: 32px;
  text-align: end;
`;

export const AutosaveInfo = styled.div`
  font-size: 11px;
  color: ${autosaveInfoColor};
  line-height: 15px;
`;

export const AutosaveTitle = styled.div`
  font-size: 13px;
  color: ${darkgrey};
  line-height: 18px;
`;
